import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShareddataService {
  private data: any;
  constructor() {}

  // Method to set data
  setData(data: any) {
    this.data = data;
  }

  // Method to get data
  getData() {
    return this.data;
  }
}
